module.exports = __webpack_public_path__ + "static/media/pet-bg.39c2fa7a.png";